/* eslint-disable no-unused-vars */
import { observable, action, makeObservable } from 'mobx';
import {
    getCourseDetail,
    getStudentNum,
    addCollect,
    cancelCollect,
    getOpenChapterList,
    projectCheck,
    getChapterList,
    getLecturerDetail,
    getTrialListeningReq,
    getUserMeetingConfig
} from '@/api/openCourse';
import { courseCheck, getSignUpDesc, getSignUpConfig } from '@/api/teachingBusiness';
import { getProductDetail } from '@/api/Payment/order';
import { getProjectConfig } from '@/api/project';
import ToastUtils from '@/utils/ToastUtils';
import _ from 'lodash';
import { convertTree, sortTreeData } from '@/utils/convertTree';

class Detail {
    constructor() {
        makeObservable(this);
    }

    @observable state = {
        data: {},
        learnNum: 0,
        urlData: {},
        chapterList: [],
        isProjectStudent: false,
        productDetail: {},
        projectConfig: {}, //防作弊
        join_flag: false,
        sku_info: {
            price: '20',
            stock: 0
        },
        trialListeningConfig: {}
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };
    //查询防作弊
    getProjectConfig = async () => {
        let { business_id, template_id } = this.state.urlData,
            res = await getProjectConfig({ business_id, template_id });
        if (res && res.success) {
            this.setState({
                projectConfig: res.data
            });
        }
        return res;
    };
    //查询是否配置报名
    getSignUpConfig = async () => {
        let { business_id, template_id } = this.state.urlData,
            res = await getSignUpConfig(business_id, template_id);
        if (res && res.success) {
            this.setState({
                enroll_business_id: res.data?.enroll_business_id ? res.data?.enroll_business_id : '',
                enroll_template_id: res.data?.enroll_template_id ? res.data?.enroll_template_id : ''
            });
        }
        return res;
    };
    getSignUpDesc = async (isLogin) => {
        let { business_id, template_id } = this.state.urlData;
        await this.getSignUpConfig(business_id, template_id);
        if (!isLogin) {
            return;
        }
        let res = await getSignUpDesc(this.state.enroll_business_id, this.state.enroll_template_id, business_id, template_id);
        if (res && res.success) {
            this.setState({
                signInfo: res.data,
                audit_state: res.data.audit_state
            });
        }
        this.setState({
            signInfoRes: res
        });
    };
    courseCheck = async (params) => {
        let { business_id, template_id } = this.state.urlData,
            data = {};
        if (params) {
            data = params;
        } else {
            data = {
                business_id,
                template_id
            };
        }
        try {
            const { code, msg } = await courseCheck(data);
            if (code === '00000') {
                return true;
            }
            if (code === 'A2022') {
                return code;
            }
            ToastUtils.showToast(msg);
            return false;
        } catch (error) {
            console.error('Error occurred during courseCheck:', error);
            return false;
        }
    };
    projectCheck = async (isLogin) => {
        if (!isLogin) {
            return false;
        }
        let { business_id, template_id } = this.state.urlData;
        const res = await projectCheck({ business_id, template_id });
        let flag = false;
        if (res && res.data) {
            flag = true;
        }
        this.setState({
            isProjectStudent: flag
        });
    };
    //获取学习数
    fetchNum = async () => {
        let { business_id, template_id } = this.state.urlData,
            res = await getStudentNum({ business_id, template_id });
        if (res && res.success) {
            this.setState({
                learnNum: res.data
            });
        }
    };
    //获取课程详情
    fetchDetail = async () => {
        let { business_id, template_id } = this.state.urlData,
            res = await getCourseDetail(business_id, { template_id });
        if (res && res.success) {
            this.setState({
                data: res.data
            });
        }
        return res;
    };

    //获取讲师介绍
    fetchLecturerDetail = async (id) => {
        let res = await getLecturerDetail(id);
        if (res && res.success) {
            this.setState({
                data: res.data
            });
        }
        return res;
    };
    //添加收藏
    addCollect = async (data) => {
        let res = await addCollect(data);
        if (res && res.success) {
            ToastUtils.showSuccessToast('收藏成功');
            this.fetchDetail();
        }
    };
    //取消收藏
    cancelCollect = async (data) => {
        let res = await cancelCollect(data);
        if (res && res.success) {
            ToastUtils.showSuccessToast('取消成功');
            this.fetchDetail();
        }
    };

    //获取章节列表
    fetchOpenChapterList = async (open = true) => {
        let fn = open ? getOpenChapterList : getChapterList,
            resList = [],
            { business_id, template_id } = this.state.urlData,
            res = await fn({ business_id, template_id }).catch(() => {
                return resList;
            });
        if (res && res.success) {
            resList = convertTree(sortTreeData(res.data));
            this.setState({
                chapterList: resList
            });
        }
        return resList;
    };
    //获取商品详情
    getProductDetail = async () => {
        let { business_id } = this.state.urlData,
            res = await getProductDetail(business_id);
        if (res && res.success && res.data) {
            this.setState({
                productDetail: res.data,
                sku_info: res.data.sku_info.length ? res.data.sku_info[0] : null,
                join_flag: res.data.join_flag,
                show_flag: res.data.show_flag
            });
        } else {
            this.setState({
                sku_info: null,
                join_flag: false,
                show_flag: false
            });
        }
        return res;
    };

    //获取是否试听
    getTrialListening = async (json) => {
        const res = await getTrialListeningReq(json);
        if (res && res.success) {
            this.setState({
                trialListeningConfig: res.data
            });
        }
    };
    //查询会议设置
    getUserMeetingConfigFun = async () => {
        let { business_id, template_id } = this.state.urlData,
        res = await getUserMeetingConfig(business_id);
        return res;
    };
}

export default new Detail();
